define('views/shared/video_iframe/video_iframe',['backbone',
        'views/_base/baseview',
        'text!views/shared/video_iframe/video_iframe.html'
], function (Backbone, BaseView, Template) {
    'use strict';

    return BaseView.extend({
        template: _.template(Template),
        scrollToTop: false,
        isRender: true,
        activityIndicator: false,
        tagName: 'div',
        className: 'video-iframe-wrap',
        events: {},

        initialize: function (options) {
            options = options || {};
            this.elementName = options.elementName;
            this.videoID = options.videoID; // String
            this.autoPlay = this.getAutoPlayValue( typeof(options.autoPlay) === 'boolean' ? options.autoPlay : false ); // Boolean (defaults to false)

            BaseView.prototype.initialize(this);
        },

        render: function () {
            this.$el.html( this.template() );

            return this;
        },

        getAutoPlayValue: function(bool) {
            return bool === true ? 1 : 0;
        },

        close: function () {}
    });
});
